const TRANSACTION_TIME_KEY = 'settlementTime';

export default TRANSACTION_TIME_KEY;
